import FormInput from './FormInputText';

export default function FormFieldGroup(props: any) {
	return (
		<div data-selection={props?.componentId}>
			<FormInput props={props} />
		</div>
	);
}
